import React from "react";
import MuiButton, { ButtonProps, ButtonTypeMap } from "@mui/material/Button";
import { css } from "@emotion/react";
import CircularProgress from "@mui/material/CircularProgress";

const Button = (
  { loadingMessage, thin_button, ...props }: ButtonInterface,
  ref: React.Ref<unknown>
) => {
  const backgroundColor =
    props?.variant != "text"
      ? `var(${props?.bg ?? "--color-brand-red-main"})`
      : "transparent";
  const styles = {
    root: css({
      boxShadow: "none",
      transition: "0.5s",
      fontFamily: "var(--font-family)",
      fontWeight: 700,
      fontSize: props.fs ?? 12,
      padding: thin_button ? "0.5rem 2rem" : "10px 35px 10px 35px",
      // @ts-ignore
      color: `var(${props.colortext})` ?? `var(--color-brand-bg-secondary)`,
      borderRadius: 28,
      textAlign: "center",
      backgroundColor,
      ":hover": {
        backgroundColor,
        opacity: 0.9,
        scale: "1.05",
        transition: "1s",
      },
    }),
  };
  return (
    <>
      <MuiButton
        target={props?.target}
        variant="contained"
        css={styles.root}
        {...props}
      >
        {loadingMessage ?? props.children}
        {loadingMessage && (
          <CircularProgress
            style={{ width: 20, height: 20, color: "red", marginLeft: 10 }}
          />
        )}
      </MuiButton>
    </>
  );
};

export interface ButtonInterface extends ButtonProps {
  bg?:
    | "--color-brand-red-main"
    | "--color-brand-blue-secondary"
    | "--color-brand-blue-tertiary"
    | "--color-brand-blue-main"
    | "--color-brand-green-main"
    | "--color-brand-grey-secondary"
    | "--color-brand-red-tertiary"
    | "--bg-secondary"
    | "transparent";
  colortext?:
    | "--color-brand-red-main"
    | "--color-brand-blue-secondary"
    | "--color-brand-blue-tertiary"
    | "--color-brand-blue-main"
    | "--color-brand-green-main"
    | "--color-brand-grey-secondary"
    | "--color-brand-red-main"
    | "--color-brand-red-tertiary"
    | "--bg-secondary";

  fs?: "12px" | "15px";
  variant?: "text" | "outlined" | "contained";
  thin_button?: boolean;
  component?: any;
  loadingMessage?: string | null;
  href?: string;
  rel?: string;
  target?: string;
}
export default React.forwardRef(Button);
